import { getColor } from "@chakra-ui/theme-tools";

const variantSoftRounded = (props) => {
  const { colorScheme: c, theme } = props;
  return {
    tab: {
      borderRadius: "full",
      fontWeight: "semibold",
      color: "primaryText",
      _selected: {
        color: getColor(theme, `${c}.700`),
        bg: getColor(theme, `${c}.100`),
      },
    },
  };
};

const variantLine = () => ({
  tab: {
    _focus: { boxShadow: "none" },
  },
});

const variants = {
  "soft-rounded": variantSoftRounded,
  line: variantLine,
};

export default {
  variants,
};
